import React from 'react';

import {
  WysiwygField,
} from '../../../components';

import './style.scss';

const ParagraphQuote = ({ entity }) => {
  return (
    <div className="Paragraph ParagraphQuote">
      <WysiwygField
        property="schema:text"
        className="ParagraphQuote__text"
        html={entity.getIn(['field_text', 0, 'processed'])}
      />
      {entity.get('field_author') ? (
        <div className="ParagraphQuote__author">
          {entity.getIn(['field_author', 0, 'value'])}
          {entity.get('field_author') ? (
            <span className="ParagraphQuote__author-position">
              {entity.getIn(['field_author_position', 0, 'value'])}
            </span>
          ) : null}
        </div>
      ) : null }
    </div>
  );
};

export default ParagraphQuote;
